// extracted by mini-css-extract-plugin
export var text = "_34-0";